module.exports = require("@asseinfo/react-kanban");